import {
  placeholderImage,
  placeholderCta,
} from '../../utils/helperPlaceholder';

import {
  flattenCustomImage,
  transformCta,
} from '../../utils/helperTransforms.wp';

export function transformHeroCta(data) {
  return {
    type: 'hero-cta',
    theme: 'dynamic',
    heading: data?.heading || false,
    description: data?.description || false,
    image: flattenCustomImage(data?.image),
    imageBackground: flattenCustomImage(data?.imageBackground),
    cta: transformCta(data?.cta),
    ctaSecondary: transformCta(data?.ctaSecondary),
  };
}

// Site-wide fallback for the primary CTA, set via the Global Options > Hero CTA
// options page, used whenever a page's Hero CTA block leaves the CTA empty.
export function transformHeroCtaFallback(data) {
  return transformCta(
    data?.globalOptionsDefault?.globalHerocta?.global_herocta_cta
  );
}

export const DEMO_DATA = [
  {
    type: 'hero-cta',
    theme: 'dynamic',
    heading: 'Explore our school',
    description:
      'We`ll walk you through how the school works, what a typical day looks like, and answer any questions you have.',
    image: placeholderImage,
    imageBackground: placeholderImage,
    cta: placeholderCta,
    ctaSecondary: placeholderCta,
  },
  {
    type: 'hero-cta',
    theme: 'dynamic',
    heading: 'Explore our school',
    image: placeholderImage,
    imageBackground: placeholderImage,
    cta: placeholderCta,
    ctaSecondary: placeholderCta,
  },
  {
    type: 'hero-cta',
    theme: 'dynamic',
    heading: 'Explore our school',
    description:
      'We`ll walk you through how the school works, what a typical day looks like, and answer any questions you have.',
    image: placeholderImage,
    imageBackground: placeholderImage,
    cta: placeholderCta,
  },
  {
    type: 'hero-cta',
    theme: 'dynamic',
    heading: 'Explore our school',
    description:
      'We`ll walk you through how the school works, what a typical day looks like, and answer any questions you have.',
    image: placeholderImage,
    imageBackground: placeholderImage,
  },
];
